import React, { useState, useEffect } from 'react';
import StatusDot from './StatusDot';

const api = (path) => fetch(`/api${path}`).then(r => r.ok ? r.json() : null).catch(() => null);

const TYPE_ICONS = { container: '📦', server: '🖥', device: '📱', vm: '💻', service: '⚙' };
const TABS = [
  { key: 'devices', label: 'Geraete' },
  { key: 'server', label: 'Server' },
  { key: 'container', label: 'Container' },
  { key: 'network', label: 'Netzwerk' },
];

function NodeCard({ node, accent }) {
  return (
    <div className="card" style={{ padding: 'var(--gap-sm)', display: 'flex', alignItems: 'flex-start', gap: 'var(--gap-sm)' }}>
      <div style={{ width: 36, height: 36, borderRadius: 'var(--border-radius)', background: `${accent}20`, color: accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>
        {TYPE_ICONS[node.type] || '⚙'}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
          <StatusDot status={node.status === 'online' ? 'ok' : node.status === 'offline' ? 'error' : 'off'} size={6} />
          <span style={{ fontWeight: 600, fontSize: 'var(--font-size-sm)' }}>{node.name}</span>
          <span className="badge badge-off" style={{ fontSize: 8 }}>{node.type}</span>
        </div>
        {node.ip && <div style={{ fontSize: 10, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)' }}>{node.ip}</div>}
        {node.uptime && <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Uptime: {node.uptime}</div>}
        {node.info && <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>{node.info}</div>}
        {node.links && node.links.length > 0 && (
          <div style={{ display: 'flex', gap: 3, marginTop: 4, flexWrap: 'wrap' }}>
            {node.links.map((l, i) => <span key={i} className="badge badge-off" style={{ fontSize: 8 }}>{l}</span>)}
          </div>
        )}
      </div>
    </div>
  );
}

export default function NodesView({ domain = 'ops', accentColor }) {
  const accent = accentColor || `var(--accent-${domain})`;
  const [tab, setTab] = useState('container');
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api(`/nodes?domain=${domain}`).then(d => {
      setNodes(d?.nodes || []);
      setLoading(false);
    });
  }, [domain]);

  const filtered = nodes.filter(n => {
    if (tab === 'devices') return n.type === 'device' || n.type === 'vm';
    if (tab === 'server') return n.type === 'server';
    if (tab === 'container') return n.type === 'container';
    if (tab === 'network') return true;
    return true;
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-md)' }}>
      {/* Sub-Tab Bar */}
      <div style={{ display: 'flex', gap: 2, borderBottom: '1px solid var(--border)' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '8px 16px', fontSize: 'var(--font-size-sm)', background: 'none', border: 'none', cursor: 'pointer',
            color: tab === t.key ? accent : 'var(--text-muted)',
            borderBottom: tab === t.key ? `2px solid ${accent}` : '2px solid transparent',
          }}>{t.label}</button>
        ))}
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 'var(--gap-sm)' }}>
          <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' }}>{nodes.length} Nodes</span>
        </div>
      </div>

      {loading && <div style={{ color: 'var(--text-muted)' }}>Lade Nodes...</div>}

      {!loading && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--gap-sm)' }}>
          {filtered.map((node, i) => <NodeCard key={node.id || i} node={node} accent={accent} />)}
          {filtered.length === 0 && (
            <div style={{ gridColumn: '1 / -1', color: 'var(--text-muted)', textAlign: 'center', padding: '2rem' }}>
              Keine Nodes in dieser Kategorie
            </div>
          )}
        </div>
      )}
    </div>
  );
}
